import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { IntlProvider } from 'react-intl';
import Helmet from 'react-helmet';

import { loadLanguages } from 'actions/languages';

const AppProvider = ({ locale, messages, children, startLoading }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (startLoading) {
      dispatch(loadLanguages());
    }
  }, []);

  return (<React.Fragment>
    <Helmet htmlAttributes={ { lang: locale } }>
      <title>
        { /* eslint-disable-next-line react/prop-types */ }
        { messages['app.title'] ?? 'Please wait...' }
      </title>
    </Helmet>
    <IntlProvider locale={ locale } messages={ messages } key={ locale }>
      { children }
    </IntlProvider>
  </React.Fragment>);
};

AppProvider.propTypes = {
  locale: PropTypes.string.isRequired,
  messages: PropTypes.shape({}),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  startLoading: PropTypes.bool
};

AppProvider.defaultProps = {
  children: null,
  messages: null,
  startLoading: true
};

const mapDispatchToProps = dispatch => ({ dispatch });

function mapStateToProps(state) {
  const {
    app: { locale, messages }
  } = state;

  return {
    locale,
    messages
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AppProvider);
